const PLAN_LABELS = {
  trial: "Trial",
  basic: "Basic",
  starter: "Starter",
  smart: "Growth",
  growth: "Growth",
  advanced: "Pro",
  pro: "Pro",
  enterprise: "Enterprise",
};

const STAGE_LABELS = {
  unknown: "Unknown",
  pendingapproval: "PendingApproval",
  rejected: "Rejected",
  inactivedeleted: "InactiveDeleted",
  trial: "Trial",
  active: "Active",
  atrisk: "AtRisk",
  dormant: "Dormant",
  nousagepostapproval: "NoUsagePostApproval",
};

function normalizePlanLabel(raw) {
  if (raw == null) return "";
  const key = String(raw).trim().toLowerCase();
  return PLAN_LABELS[key] || String(raw);
}

function normalizeStage(raw) {
  if (raw == null) return "";
  const key = String(raw).trim().replace(/[\s_-]/g, "").toLowerCase();
  return STAGE_LABELS[key] || String(raw);
}

function computeDaysToTrialEnd(rawDate) {
  if (!rawDate) return null;
  const end = new Date(rawDate);
  if (Number.isNaN(end.getTime())) return null;
  const now = new Date();
  const diffMs = end.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function normalizeAccountSnapshot(raw) {
  if (!raw || typeof raw !== "object") return {};

  const businessId = raw.businessId || raw.id || "";
  const lifecycleStage = normalizeStage(
    raw.lifecycleStage || raw.stage || raw.lifecycle
  );

  const trialEndsOn =
    raw.trialEndsOn ||
    raw.trialEndsAt ||
    raw.trialEndDate ||
    raw.quotaResetDate ||
    null;

  const lastActiveOn =
    raw.lastActiveOn ||
    raw.lastMessageAt ||
    raw.lastSeenAt ||
    raw.lastActivityOn ||
    null;

  const planName = normalizePlanLabel(
    raw.planName || raw.planType || raw.plan || raw.subscriptionPlan
  );

  const hasWhatsAppConfigured =
    raw.hasWhatsAppConfigured ?? raw.hasWhatsAppConfig ?? false;
  const hasActiveWhatsAppNumber =
    raw.hasActiveWhatsAppNumber ?? raw.hasActiveWaNumber ?? false;
  const whatsAppConnected =
    raw.whatsAppConnected ??
    (raw.whatsAppStatus === "Connected" || hasActiveWhatsAppNumber);

  const isTrial = raw.isTrial ?? String(planName).toLowerCase() === "trial";

  return {
    ...raw,
    id: raw.id || businessId,
    businessId,
    businessName: raw.businessName || raw.name || "",
    ownerEmail: raw.ownerEmail || raw.businessEmail || "",
    lifecycleStage,
    stage: lifecycleStage,
    planName,
    planType: raw.planType || raw.plan || planName,
    trialEndsOn,
    trialEndDate: raw.trialEndDate || raw.trialEndsAt || trialEndsOn,
    lastActiveOn,
    createdAt: raw.createdAt || raw.createdOn || null,
    hasWhatsAppConfigured,
    hasWhatsAppConfig: hasWhatsAppConfigured,
    hasActiveWhatsAppNumber,
    whatsAppConnected: Boolean(whatsAppConnected),
    isTrial,
    daysToTrialEnd:
      typeof raw.daysToTrialEnd === "number"
        ? raw.daysToTrialEnd
        : computeDaysToTrialEnd(trialEndsOn),
  };
}

export function normalizeAccountSnapshots(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeAccountSnapshot);
}
